(() => {
  angular
    .module('gm.common.services')
    .factory('gmAvatar', gmAvatarService);

  function gmAvatarService(
    $q,
    GmyToken,
    gmApi,
    Upload
  ) {
    'ngInject';

    let _avatarTimestamp = Date.now();

    return {
      getAvatarTimestamp,
      refreshAvatars,
      updateAvatar,
    };

    function getAvatarTimestamp() {
      return _avatarTimestamp;
    }

    function refreshAvatars() {
      _avatarTimestamp = Date.now();
    }

    function updateAvatar(file) {
      const _this = this;
      const defer = $q.defer();

      Upload.upload({
        url: `${gmApi.getApiBasePath()}users/avatars`,
        file,
        headers: {
          'X-Auth-Token': GmyToken.getToken()
        }
      })
        .progress((evt) => {
          defer.notify(evt);
        })
        .success(() => {
          _this.refreshAvatars();
          defer.resolve();
        })
        .error((error) => {
          defer.reject(error);
        });

      return defer.promise;
    }
  }
})();
